<template>
  <b-field :class="$attrs.class"
           :type="error ? 'is-danger': null"
           :message="error ?? null"
           :expanded="expanded"
           :label="label">
    <b-select v-model="modelValue" :placeholder="placeholder" :expanded="expanded">
      <slot/>
    </b-select>
  </b-field>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    placeholder: String,
    expanded: Boolean,
    value: {
      required: true,
    },
  },
  computed: {
    modelValue: {
      get() { return this.value },
      set(newValue) {
        // console.log('setting new value', newValue);
        this.$emit('input', newValue);
      },
    },
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
